import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const StyleSvgWrapper = styled.div<{ styleSvg?: string }>`
  ${(props) => props.styleSvg};
`
